import { render, staticRenderFns } from "./ResetPasswordDone.vue?vue&type=template&id=5c9dc31b&"
import script from "./ResetPasswordDone.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordDone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports